// Module-init capture for the Android/Chromium `beforeinstallprompt` event.
//
// Imported once for side-effects from components/app-providers.tsx. Doing this
// at module evaluation (instead of inside a React effect) means the deferred
// prompt is captured even if it fires before the component that needs it
// renders — common on the home card path where the event has often fired
// while the user was on /sign-in or /splash.
//
// Also clears the stored prompt on `appinstalled` so the banner/card hide
// immediately after a successful install.

import { usePwaStore, type BeforeInstallPromptEvent } from "./store/pwa"

if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault()
    usePwaStore.getState().setDeferredPrompt(e as BeforeInstallPromptEvent)
  })

  window.addEventListener("appinstalled", () => {
    usePwaStore.getState().setDeferredPrompt(null)
  })
}
